// import { HEX, RGB, RGBA, CssVariables } from "./types";

// export const colorsCssVariables: CssVariables<RGBA | RGB | HEX | "transparent"> = {
export const colorsCssVariables = {
    // Base colors
    '--color-base-brickwork-orange': '#E64B28FF',
    '--color-base-charcoal': '#171717FF',
    '--color-base-off-white': '#FFFDF5FF',

    // Shades
    '--color-shade-medium-orange': '#D53A17FF',
    '--color-shade-light-charcoal': '#1F1F1EFF',
    '--color-shade-light-beige': '#F6F4ECFF',

    // Semantic colors
    '--color-semantic-green': '#497A52FF',
    '--color-semantic-yellow': '#DD9335FF',
    '--color-semantic-red': '#BB271AFF',

    // Opacity variants - Charcoal
    '--color-opacity-charcoal-90': '#171717E6',
    '--color-opacity-charcoal-70': '#171717B3',
    '--color-opacity-charcoal-50': '#17171780',
    '--color-opacity-charcoal-30': '#1717174D',
    '--color-opacity-charcoal-15': '#17171726',
    '--color-opacity-charcoal-5': '#1717170D',
    '--color-opacity-charcoal-0': '#17171700',

    // Opacity variants - Off White
    '--color-opacity-off-white-90': '#FFFDF5E6',
    '--color-opacity-off-white-70': '#FFFDF5B3',
    '--color-opacity-off-white-50': '#FFFDF580',
    '--color-opacity-off-white-30': '#FFFDF54D',
    '--color-opacity-off-white-15': '#FFFDF526',
    '--color-opacity-off-white-5': '#FFFDF50D',
    '--color-opacity-off-white-0': '#FFFDF500',

    // Opacity variants - Orange (base #E64B28)
    '--color-opacity-orange-90': '#E64B28E6',
    '--color-opacity-orange-70': '#E64B28B3',
    '--color-opacity-orange-50': '#E64B2880',
    '--color-opacity-orange-30': '#E64B284D',
    '--color-opacity-orange-15': '#E64B2826',
    '--color-opacity-orange-5': '#E64B280D',
    '--color-opacity-orange-0': '#E64B2800',

    // Opacity variants - Light Beige (base #F6F4EC)
    '--color-opacity-light-beige-90': '#F6F4ECE6',
    '--color-opacity-light-beige-70': '#F6F4ECB3',
    '--color-opacity-light-beige-50': '#F6F4EC80',
    '--color-opacity-light-beige-30': '#F6F4EC4D',
    '--color-opacity-light-beige-15': '#F6F4EC26',
    '--color-opacity-light-beige-5': '#F6F4EC0D',
    '--color-opacity-light-beige-0': '#F6F4EC00',
} as const;

export type CssColors = typeof colorsCssVariables;
export type BaseCssColorKey = keyof CssColors;

// Extended color key that includes both base colors and semantic UI colors
// Also allows any CSS variable starting with -- for flexibility with legacy colors
export type CssColorKey = BaseCssColorKey | `--${string}`;
